<template>
  <TwoColumnFormCard>
    <div class="py-24 text-center">
      <div class="mx-auto w-9 text-gray-500">
        <slot name="icon"></slot>
      </div>

      <h2 class="mt-2 text-lg font-medium text-gray-500">{{ title }}</h2>
      <p class="mt-1 text-sm text-gray-500">
        {{ message }}
      </p>
    </div>
  </TwoColumnFormCard>
</template>

<script setup>
import TwoColumnFormCard from './TwoColumnFormCard.vue'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
})
</script>
